module.exports = __webpack_public_path__ + "d664201f/img/placeholder.888fcd0b.svg";